import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import BrandAllListContainer from '../../containers/brand/BrandAllListContainer';
import { BRAND_PAGE_NAME } from '../../constants/service/app/brandConstants';

const BrandAllList = () => {
  return (
    <PageTemplate pageName={BRAND_PAGE_NAME.BRAND_LIST}>
      <BrandAllListContainer pageName={BRAND_PAGE_NAME.BRAND_LIST} />
    </PageTemplate>
  );
};

export default BrandAllList;
